export default __webpack_public_path__ + "static/media/tiktok.b1b6bcc1.gif";